<template>
  <div class="p-4 container">
    <!-- warning banner -->
    <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
      Warning: This page is still under development
    </div>
    <h1>TFA Tokens</h1>
    <p>Welcome {{ props.user.email }}</p>
    <div>
      <span class="p-4 cursor-pointer" :class="{'font-bold': state.activeTab === 0}" @click="state.activeTab = 0">Tokens</span>
      <span class="p-4 cursor-pointer" :class="{'font-bold': state.activeTab === 1}" @click="state.activeTab = 1">Devices</span>
    </div>
    <div>
      <div v-if="state.activeTab === 0">
        <div v-for="displayToken in state.displayedTokens" :key="displayToken.tfa_token.id">
          <div v-if="displayToken.isSelected" class="my-4 p-4 bg-white rounded-md shadow-md">
            <h2>{{ displayToken.tfa_token.name }}</h2>

            <label for="selectedTokenName" class="font-medium">Name</label>
            <input type="text" v-model="displayToken.tfa_token.name" id="selectedTokenName" />

            <label for="selectedTokenValue" class="font-medium">Token</label>
            <input type="text" v-model="displayToken.tfa_token.token" id="selectedTokenValue" />

            <div class="flex items-center">
              <div class="p-4 inline-block"><TimeFraction :timeLeft="2" :totalTime="30" /></div>
              <span class="text-4xl font-bold">123456</span>
            </div>

            <div class="flex justify-between mt-4">
              <button @click="deleteToken()" class="outline-delete">Delete</button>
              <button @click="saveCurrentToken()" class="primary">Save</button>
            </div>
          </div>
          <div v-if="!displayToken.isSelected" class="my-4 p-4 bg-white rounded-md shadow-md flex justify-between items-center">
            <div>
              <span class="mx-2">{{displayToken.tfa_token.name}}</span>
              <span class="mx-2">{{displayToken.tfa_token.token}}</span>
            </div>
            <button @click="edit(displayToken)">Edit</button>
          </div>
        </div>
        <button @click="addToken()">Add Token</button>
      </div>
      <div v-if="state.activeTab === 1">
        <div v-for="device in props.tfa_devices" :key="device.id">
          <p>{{ device.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {reactive} from 'vue'
import TimeFraction from './TfaTokens/TimeFraction.vue'
import { router } from '@inertiajs/vue3'
import {getCode, BasedValue} from "../../helpers/tfa.js";

window.getCode = getCode;
window.BasedValue = BasedValue;

const props = defineProps({
  user: Object,
  tfa_tokens: Array[Object],
  tfa_devices: Array[Object],
})

console.log({...props})

let state = reactive({
  activeTab: 0,
  displayedTokens: props.tfa_tokens.map((tfa_token) => {
    return {
      isSelected: false,
      tfa_token: tfa_token,
      code: "" //getCode(BasedValue(tfa_token.token).toString(256), {})
    }
  })
})

function addToken() {
  console.log('addToken')
  state.currentToken = {
    name: 'New Token',
    token: '1234567890'
  }
}

function saveCurrentToken() {
  console.log('saveCurrentToken')
  router.post('/tfa_tokens', state.currentToken)
  state.currentToken = null
}

function edit(displayToken) {
  console.log('edit')
  state.displayedTokens.forEach((displayedToken) => {
    displayedToken.isSelected = false
  })
  displayToken.isSelected = true
}

</script>